import styled from '@emotion/styled';
import { Trans } from '@lingui/macro';
import { Text } from 'components/text/Text';

export const SelectedRowCount = ({ rowSelectionCount }: { rowSelectionCount?: number }) => {
  return (
    <StyledText variant="labelSm" weight="regular">
      <Bold>{rowSelectionCount}</Bold> <Trans>Selected</Trans>
    </StyledText>
  );
};

const StyledText = styled(Text)`
  color: ${p => p.theme.palette.text.tertiary};
  display: flex;
  justify-content: flex-end;
  padding-block: 16px;
  padding-right: 4px;
  min-width: 98px;
  gap: 4px;
  white-space: nowrap;
`;

const Bold = styled.b`
  font-weight: 600;
  color: ${p => p.theme.palette.text.secondaryHover};
`;
